/* tslint:disable */
/* eslint-disable */
/**
 * FMS Run API
 * The FMS Run API description
 *
 * The version of the OpenAPI document: 1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */



/**
 * 
 * @export
 * @interface AddressDto
 */
export interface AddressDto {
    /**
     * Address unique identifier
     * @type {string}
     * @memberof AddressDto
     */
    'id': string;
    /**
     * User ID who owns this address
     * @type {string}
     * @memberof AddressDto
     */
    'userId': string;
    /**
     * Address name/label
     * @type {string}
     * @memberof AddressDto
     */
    'name': string;
    /**
     * Contact number for this address
     * @type {string}
     * @memberof AddressDto
     */
    'contactNumber': string;
    /**
     * Address type
     * @type {string}
     * @memberof AddressDto
     */
    'type': AddressDtoTypeEnum;
    /**
     * Country name
     * @type {string}
     * @memberof AddressDto
     */
    'country': string;
    /**
     * Country code
     * @type {string}
     * @memberof AddressDto
     */
    'countryCode': string;
    /**
     * Province name
     * @type {string}
     * @memberof AddressDto
     */
    'province': string;
    /**
     * Province code
     * @type {string}
     * @memberof AddressDto
     */
    'provinceCode': string;
    /**
     * City name
     * @type {string}
     * @memberof AddressDto
     */
    'city'?: string;
    /**
     * City code
     * @type {string}
     * @memberof AddressDto
     */
    'cityCode'?: string;
    /**
     * Barangay name
     * @type {string}
     * @memberof AddressDto
     */
    'barangay'?: string;
    /**
     * Barangay code
     * @type {string}
     * @memberof AddressDto
     */
    'barangayCode'?: string;
    /**
     * Street address
     * @type {string}
     * @memberof AddressDto
     */
    'street'?: string;
    /**
     * Additional address line (apartment, unit, floor, building)
     * @type {string}
     * @memberof AddressDto
     */
    'addressLine2'?: string;
    /**
     * Postal code
     * @type {string}
     * @memberof AddressDto
     */
    'postalCode'?: string;
    /**
     * Source API for address data
     * @type {string}
     * @memberof AddressDto
     */
    'sourceApi'?: AddressDtoSourceApiEnum;
    /**
     * Full formatted address
     * @type {string}
     * @memberof AddressDto
     */
    'fullAddress'?: string;
}

export const AddressDtoTypeEnum = {
    Home: 'home',
    Work: 'work',
    Shipping: 'shipping'
} as const;

export type AddressDtoTypeEnum = typeof AddressDtoTypeEnum[keyof typeof AddressDtoTypeEnum];
export const AddressDtoSourceApiEnum = {
    SymphApi: 'symph-api',
    PsgcGitlab: 'psgc-gitlab',
    PsgcCloud: 'psgc-cloud'
} as const;

export type AddressDtoSourceApiEnum = typeof AddressDtoSourceApiEnum[keyof typeof AddressDtoSourceApiEnum];


